module.exports = __webpack_public_path__ + "static/media/clinic-medical.3bc07792.svg";